export const APPLY_COUPON = "APPLY_COUPON";
export const REMOVE_COUPON = "REMOVE_COUPON";
